import { render, staticRenderFns } from "./CardCounters.vue?vue&type=template&id=195716ae"
import script from "./CardCounters.vue?vue&type=script&lang=js"
export * from "./CardCounters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports